import React from 'react';

const Result = ({ result }) => (
  <div>
    Result: <span>{result}</span>
  </div>
);

export default Result;